/* global gon, I18n */
import React from 'react'
import PropTypes from 'prop-types'

const SUPPORTED_PRODUCT_TYPE = '3d_models'

const buildPreviewUrl = (id) => {
  return `${gon.external_turbosquid_draft_preview_url}${id}`
}

const ActionsCell = ({
  id,
  product_type = null,
}) => {
  if (product_type && product_type !== SUPPORTED_PRODUCT_TYPE) {
    return (
      <span className="action-icon">
        <span title={I18n.t('turbosquid.products.non_3d_tooltip')}>
          <i className="fa fa-eye" />
        </span>
      </span>
    )
  }

  return (
    <span className="action-icon">
      <a href={buildPreviewUrl(id)} target="_blank" rel="noopener noreferrer">
        <i className="fa fa-eye" data-toggle="tooltip" title={I18n.t('turbosquid.products.preview_draft')} />
      </a>
    </span>
  )
}

ActionsCell.propTypes = {
  id: PropTypes.string.isRequired,
  product_type: PropTypes.string,
}

export default ActionsCell
